export const GAME_ID = 'GameId';
export const PLAY_ID = 'playId';

export const FOOTBALL_DOWN_DISTANCE = 'fb.DownAndDistance';
export const FOOTBALL_FIELD_ZONE = 'fb.YardsToGL';
export const FOOTBALL_TEAMS = 'ScoutedTeams.teamOrganization';
export const FOOTBALL_SEASON = 'GameSeason';
export const FOOTBALL_GAMES_ABBR_WITH_DATE = 'GameName.FullAbbrevWithDate';
export const FOOTBALL_GAME_DATE = 'GameDate';
export const FOOTBALL_GAMES_WITH_CODE = 'GameName.FullCodeWithDate';
export const FOOTBALL_FULL_ORG_WITH_DATE = 'GameName.FullOrgWithDate';
export const FOOTBALL_GAME_NAME_SHORT_ABBR = 'GameName.ShortAbbrev';
export const FOOTBALL_GAME_NAME_SHORT_ABBR_DATE = 'GameName.ShortAbbrevWithDate';
export const FOOTBALL_GAME_SHORT_CODE = 'GameName.ShortCode';
export const FOOTBALL_GAME_SHORT_CODE_DATE = 'GameName.ShortCodeWithDate';
export const FOOTBALL_GAME_SHORT_ORG = 'GameName.ShortOrg';
export const FOOTBALL_GAME_SHORT_ORG_DATE = 'GameName.ShortOrgWithDate';
